import { IPreProcessedGeneratedTasksModel, IGeneratedTasksModel } from "../../modules/tasks/model/types";

export function mapGeneratedTask(generatedTask: IPreProcessedGeneratedTasksModel) : IGeneratedTasksModel
{
    generatedTask.location = generatedTask.locationArray.join("|");
    // console.log(generatedTask);
    return generatedTask as IGeneratedTasksModel;
}